export default __webpack_public_path__ + "static/media/BikeBlue.ea990ddf.png";